{
  "nm": "Main Scene",
  "ddd": 0,
  "h": 500,
  "w": 500,
  "meta": { "g": "@lottiefiles/creator 1.61.0" },
  "layers": [
    {
      "ty": 4,
      "nm": "Shape Layer 5",
      "sr": 1,
      "st": 20,
      "op": 620,
      "ip": 20,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251, 250, 0] },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 20 },
            { "s": [360], "t": 110 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, -100] },
              "s": { "a": 0, "k": [10, 10] }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 0 },
              "c": { "a": 0, "k": [0, 0, 0] }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.9843, 0.4353, 0.4157] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Shape Layer 4",
      "sr": 1,
      "st": 15,
      "op": 615,
      "ip": 15,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251, 250, 0] },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 15 },
            { "s": [360], "t": 105 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, -100] },
              "s": { "a": 0, "k": [20, 20] }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 0 },
              "c": { "a": 0, "k": [0, 0, 0] }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.9843, 0.4353, 0.4157] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "Shape Layer 3",
      "sr": 1,
      "st": 10,
      "op": 610,
      "ip": 10,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251, 250, 0] },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 10 },
            { "s": [360], "t": 100 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, -100] },
              "s": { "a": 0, "k": [30, 30] }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 0 },
              "c": { "a": 0, "k": [0, 0, 0] }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.9843, 0.4353, 0.4157] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 3
    },
    {
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "st": 5,
      "op": 605,
      "ip": 5,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251, 250, 0] },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 5 },
            { "s": [360], "t": 95 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, -100] },
              "s": { "a": 0, "k": [40, 40] }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 0 },
              "c": { "a": 0, "k": [0, 0, 0] }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.9843, 0.4353, 0.4157] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 4
    },
    {
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "st": 0,
      "op": 600,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [250, 250, 0] },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 0 },
            { "s": [360], "t": 90 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, -100] },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.333, "y": 0 },
                    "i": { "x": 0.667, "y": 1 },
                    "s": [50, 50],
                    "t": 0
                  },
                  {
                    "o": { "x": 0.333, "y": 0 },
                    "i": { "x": 0.667, "y": 1 },
                    "s": [40, 40],
                    "t": 84
                  },
                  { "s": [50, 50], "t": 100 }
                ]
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 0 },
              "c": { "a": 0, "k": [0, 0, 0] }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.9843, 0.4353, 0.4157] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 5
    }
  ],
  "v": "5.7.0",
  "fr": 60,
  "op": 106,
  "ip": 0,
  "assets": []
}
